export enum InViewType {
  LANDSCHAP
}
